import { createAsyncAction, createStandardAction } from 'typesafe-actions'
import {
  SupplierInvoiceListReq,
  SupplierInvoiceListRes,
  ActionSupplierInvoiceRes,
  UpdateSupplierInvoiceReq,
  SupplierInvoiceDetailReq,
  SupplierInvoiceDetailRes,
  PaymentReq,
  PaymentRes,
  PatialDetailReq,
  PatialDetailRes,
  CountReq,
  CountRes,
} from './types'

export const getSupplierInvoiceListAction = createAsyncAction(
  'SUPPLIER_INVOICE/GET_SUPPLIER_INVOICE_LIST_REQ',
  'SUPPLIER_INVOICE/GET_SUPPLIER_INVOICE_LIST_SUCCESS',
  'SUPPLIER_INVOICE/GET_SUPPLIER_INVOICE_LIST_FAILURE',
)<SupplierInvoiceListReq, SupplierInvoiceListRes, Error>()

export const getSupplierInvoiceDetailAction = createAsyncAction(
  'SUPPLIER_INVOICE/GET_SUPPLIER_INVOICE_DETAIL_REQ',
  'SUPPLIER_INVOICE/GET_SUPPLIER_INVOICE_DETAIL_SUCCESS',
  'SUPPLIER_INVOICE/GET_SUPPLIER_INVOICE_DETAIL_FAILURE',
)<SupplierInvoiceDetailReq, SupplierInvoiceDetailRes, Error>()

export const updateSupplierInvoiceAction = createAsyncAction(
  'SUPPLIER_INVOICE/UPDATE_SUPPLIER_INVOICE_REQ',
  'SUPPLIER_INVOICE/UPDATE_SUPPLIER_INVOICE_SUCCESS',
  'SUPPLIER_INVOICE/UPDATE_SUPPLIER_INVOICE_FAILURE',
)<UpdateSupplierInvoiceReq, ActionSupplierInvoiceRes, Error>()

export const updatePaymentAction = createAsyncAction(
  'SUPPLIER_INVOICE/UPDATE_PAYMENT_REQ',
  'SUPPLIER_INVOICE/UPDATE_PAYMENT_SUCCESS',
  'SUPPLIER_INVOICE/UPDATE_PAYMENT_FAILURE',
)<PaymentReq, PaymentRes, Error>()

export const getPatialDetailAction = createAsyncAction(
  'SUPPLIER_INVOICE/GET_PATIAL_DETAIL_REQ',
  'SUPPLIER_INVOICE/GET_PATIAL_DETAIL_SUCCESS',
  'SUPPLIER_INVOICE/GET_PATIAL_DETAIL_FAILURE',
)<PatialDetailReq, PatialDetailRes, Error>()

export const getCountAction = createAsyncAction(
  'SUPPLIER_INVOICE/GET_COUNT_REQ',
  'SUPPLIER_INVOICE/GET_COUNT_SUCCESS',
  'SUPPLIER_INVOICE/GET_COUNT_FAILURE',
)<CountReq, CountRes, Error>()

export const clearEventAction = createStandardAction('SUPPLIER_INVOICE/CLEAR_EVENT')<void>()
